import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { getPermissionsList } from '../slices/veloxity/auth/permissionsManagement/getPermissionList';

const PermissionsChecker = () => {
  const dispatch = useDispatch();

  useEffect(() => {
    const fetchPermissions = async () => {
      try {
        const response = await dispatch(getPermissionsList()).unwrap();
      } catch (error) {
        console.error("Error fetching permissions:", error);
      }
    };

    const intervalId = setInterval(() => {
      fetchPermissions();
    }, 10 * 60 * 1000); // 10 dakikada bir çağrı

    return () => clearInterval(intervalId);
  }, [dispatch]);

  return null; 
};

export default PermissionsChecker;
